import { useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router';

type ScrollAreaType = 'auto' | 'hover';

// If the OS reserves gutter width for scrollbars, we use Mantine's `auto`
// so the scrollbar is visible whenever content overflows.
//
// Otherwise we use `hover`
//
// Re-probes on every route change because there's no event for the OS
// scrollbar setting being toggled mid-session.
export function useScrollAreaType(): ScrollAreaType {
  const { pathname } = useLocation();
  const [type, setType] = useState<ScrollAreaType>(detectScrollAreaType);

  useLayoutEffect(() => {
    setType(detectScrollAreaType());
  }, [pathname]);

  return type;
}

function detectScrollAreaType(): ScrollAreaType {
  if (typeof document === 'undefined') return 'hover';

  const probe = document.createElement('div');
  probe.style.cssText =
    'width:100px;height:100px;overflow:scroll;position:absolute;top:-9999px;visibility:hidden';
  document.body.appendChild(probe);
  const scrollbarGutterWidth = probe.offsetWidth - probe.clientWidth;
  const hasClassicScrollbars = scrollbarGutterWidth > 0;
  document.body.removeChild(probe);

  return hasClassicScrollbars ? 'auto' : 'hover';
}
